import { AbstractControl, ValidationErrors } from "@angular/forms";
import { isAlpha as CVisAlpha } from 'class-validator';

export const isAlpha = (control: AbstractControl): ValidationErrors | null => {
    return control.value !== "" && !CVisAlpha(control.value) ? { alpha: 'invalid' } : null;
}